import { types } from 'mobx-state-tree';

export const MetricsModel = types.model({
    id: types.maybeNull(types.number),
    label: types.maybeNull(types.string),
    value: types.maybeNull(types.number)
});
